import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  fieldObjectNotasVersao,
  headersNotasVersao,
  valoresExibidosOffCanvasNotasVersao,
} from './auxiliarNotasVersao';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import SelectInput from '../../../../components/InputNew/Select';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import BolinhaTabelaStatus from '../../../../components/bolinhaTabelaStatus';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { useInterfaceSisaf } from '../../../../services/enum/useInterfaceSisaf';
import { useStatusVersao } from '../../../../services/enum/useStatusVersao';
import { getAllNotasVersao } from '../../../../services/gestaoSisAF/notaVersaoSisafService';
import { ENTITY } from '../../../../utils/entityNames';
import {
  ExportToExcel,
  formataNomeMeioSiglas,
  formatDate,
  formatDateSimp,
} from '../../../../utils/functions';
import { getSubAbas } from '../subabas';

const MaisOpcoesNotasVersao: React.FC = () => {
  //Dados do usuário
  const user = getUser();
  const userID = user.sub;
  const entity = ENTITY.ENTITY_NotaVersaoSisAF;
  const statusVersao = useStatusVersao();
  const navigate = useNavigate();
  const interfaceSisaf = useInterfaceSisaf();

  //Dados do componente

  const [data, setData] = useState<any[]>([]);

  const [formFiltros, setFormFiltros] = useState({
    interfaceSisAf: 0,
    descricao: '',
  });

  // Buscar dados
  const fetchData = async () => {
    try {
      const registros = await getAllNotasVersao();
      setData(registros);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  //Dados da tabela
  const tableData = data
    .filter((item) => {
      const correspondeInterface =
        formFiltros.interfaceSisAf === 0 ||
        item.interfaceSisAf === formFiltros.interfaceSisAf;

      const correspondeDescricao =
        formFiltros.descricao.trim() === '' ||
        item.descricao
          .toLowerCase()
          .includes(formFiltros.descricao.toLowerCase());

      return correspondeInterface && correspondeDescricao;
    })
    .map((item) => {
      const status =
        item.statusVersao === 2 ? 'S' : item.statusVersao === 1 ? 'A' : 'N';

      return {
        id: item.id,
        statusVersao: <BolinhaTabelaStatus status={status} />,
        dataPrevista: formatDateSimp(item.dataPrevista),
        dataVersao: formatDateSimp(item.dataVersao),
        tagVersao: item.tagVersao,
        descricao: item.descricao,
        titulo: item.titulo,
      };
    });

  //Dados do Offcanvas
  const offCanvasData = data.map((item) => ({
    id: item.id,
    dataRegistro:
      formatDate(item.dataRegistro) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
    dataUltimaAtualizacao:
      formatDate(item.dataUltimaAtualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

    dataUltimaVisualizacao:
      formatDate(item.dataUltimaVisualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
    nEdicoes: item.nEdicoes,
    nVisualizacoes: item.nVisualizacoes,
    separadorLog: '',
    statusVersao: statusVersao[item.statusVersao].label,
    dataVersao: formatDateSimp(item.dataVersao),
    tagVersao: item.tagVersao,
    descricao: item.descricao,
    link: (
      <a href={item.link} target="_blank" rel="noopener noreferrer">
        {item.link}
      </a>
    ),
    separadorObservacoes: '',
    observacoes: item.observacoes,
  }));

  const handleClickInserir = () => {
    navigate('ficha/dadosgerais');
  };

  interface ExportData {
    id: number;
    dataRegistro: string;
    usuarioRegistro: {
      nomeCompleto: string;
    };
    dataUltimaAtualizacao: string;
    usuarioAtualizacao: {
      nomeCompleto: string;
    };
    dataUltimaVisualizacao: string;
    usuarioUltimaVisualizacao: {
      nomeCompleto: string;
    };
    nEdicoes: number;
    nVisualizacoes: number;
    nVisualizadores: number;

    //Específicos
    statusVersao: number;
    dataVersao: string;
    tagVersao: string;
    descricao: string;
    link: string;

    //Observações
    observacoes: string;
  }

  const prepareDataForExport = (data: ExportData[]) => {
    return data.map((item) => {
      return {
        id: item.id,

        //Logs
        dataRegistro: item.dataRegistro,
        usuarioRegistro: item.usuarioRegistro.nomeCompleto,
        dataUltimaAtualizacao: item.dataUltimaAtualizacao,
        usuarioAtualizacao: item.usuarioAtualizacao.nomeCompleto,
        dataUltimaVisualizacao: item.dataUltimaVisualizacao,
        usuarioUltimaVisualizacao: item.usuarioUltimaVisualizacao.nomeCompleto,
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        nVisualizadores: item.nVisualizadores,

        //Específicos
        statusVersao: statusVersao[item.statusVersao].label,
        dataVersao: item.dataVersao,
        tagVersao: item.tagVersao,
        descricao: item.descricao,
        link: item.link,

        //Observações
        observacoes: item.observacoes,
      };
    });
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    if (name === 'interfaceSisAf') {
      const newValue = parseInt(value, 10);
      setFormFiltros({
        ...formFiltros,
        [name]: newValue,
      });
    } else {
      setFormFiltros((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleClearFiltros = () => {
    setFormFiltros({
      ...formFiltros,
      interfaceSisAf: 0,
      descricao: '',
    });
  };

  return (
    <>
      <BarraSubAbas subAbas={getSubAbas()} />

      <ContainerConteudo>
        <BoxConteudo boxTitulo="Filtros" fechado>
          <CustomRow style={{ marginTop: '-15px' }}>
            <CustomCol width="250px">
              <SelectInput
                name="interfaceSisAf"
                options={interfaceSisaf}
                label="Interface"
                value={formFiltros.interfaceSisAf}
                onChange={handleChange}
              />
            </CustomCol>
            <CustomCol>
              <Input
                name="descricao"
                label="Descrição"
                value={formFiltros.descricao}
                id="descricao"
                onChange={handleChange}
              />
            </CustomCol>
          </CustomRow>
          <CustomRow style={{ marginTop: '-15px', textAlign: 'right' }}>
            <CustomCol className="mt-3 justify-content-end align-content-end">
              <CustomButton
                label="Limpar filtros"
                bgColor="#808080" // Cor cinza
                textColor="#ffffff" // Texto branco
                onClick={handleClearFiltros}
              />
            </CustomCol>
          </CustomRow>
        </BoxConteudo>

        <Tabela
          headers={headersNotasVersao}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          displayValues={valoresExibidosOffCanvasNotasVersao}
          tituloCanvas="NOTA DA VERSÃO DO SISAF"
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          inserir
          onClickInserir={handleClickInserir}
          onClickDownload={() =>
            ExportToExcel(
              prepareDataForExport(data),
              valoresExibidosOffCanvasNotasVersao,
              fieldObjectNotasVersao,
              'sisaf_notas_versao.xlsx',
              userID,
              'DAF', // Nome da interface
              entity, // Nome da entidade
            )
          }
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default MaisOpcoesNotasVersao;
